<template lang="pug">
  include /mixins
  +b.inliner-wrapper
    +b.VALIDATION-OBSERVER.tt-space_mt--5(
      :ref="`validator${i}`",
      v-slot="{ valid }",
      tag="form",
      v-for='(el, i) in list'
      :key='`form${i}`'
    )
      ui-loader(v-if='isLoad')
      +b.tt-space_mt--3.tt-space_mb--3
        +b.g-row--align_center.--justify_between.--appearance_spaced.--space_xl(
        )
          cell(
            v-for='{ rules, name, label, type, classname, inputtype, cols, props, events, mask, appearance, text, afterList } in form_fields'
            :cols='cols || "narrow"'
            :key='`${type_name}${name}${i}`'
          )
            component(
              :is="type"
              v-if="appearance === 'text'"
              :class="classname"
            ) {{ text }}
            tag(
              v-else
              :tag='type || "d-control-input"'
              :rules="rules",
              :input-label='label'
              :type='inputtype || "text"'
              v-model='el[name]',
              :id='`${type_name}${name}${i}`'
              :ref='`${type_name}${name}${i}`'
              @input='$emit("input", list)'
              :name='name'
              v-bind='props'
              v-on='events'
              :class='classname'
            )
              template(
                #afterList=''
                v-if='afterList'
              )
                div
                  div(
                    v-if="props.options.length > 50 || props.pagination.next "
                    v-observe-visibility="visible => afterList(visible)",
                  )
          cell(
            cols='narrow'
          )
            +b.g-row--appearance_nowrap
              +b.g-cell.g-cols--narrow(
              )
                +b.inliner-btn--grey.BUTTON(
                  :title='_("Удалить")'
                  @click.prevent='remove(i)'
                )
                  +e.title.P.mdi.mdi-close
              //- +b.g-cell.g-cols--narrow
              //-   +b.tt-button--for-input.--auto(
              //-     @click.prevent='prepareData(valid, i)'
              //-   )
              //-     +b.ds-caption--size_2xs.--color_white.P {{_('Сохранить')}}
      //- +b.line-h--light
    +b.g-row--justify_start
      +b.g-cell.g-cols--narrow(
        v-if='!hint'
      )
        +b.inliner-add-btn.BUTTON(
          @click.prevent='addFields'
        )
          +e.icon.SVG(width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg")
            path(d="M9 0V18M0 9H18" stroke="#1183F6" stroke-width="2")
          +e.text.SPAN {{ btnText || _('Добавить') }}
      +b.g-cell.g-cols--12(
        v-else
      )
        +b.ds-caption.--size_md.tt-link--variant_start.--styling_default.BUTTON(
          @click.prevent='addFields'
        ) {{ hint }}

</template>
<script>
import { defaultValidatorErrorsParser } from '@app/Forms/FormMixin'
import { confirmWithPromise } from '@utils/helpers'

import {
  AnswerMessage,
} from '@utils/submit'

const eSlotsResolver = (acc, key) => {
  acc[key] = key
  return acc
}

const getESlots = keys => keys
  .reduce(eSlotsResolver, {})

const SPLITED_LENGTH = 1

export default {
  name: 'Inliner',
  props: {
    user: {},
    type_name: {

    },
    ticket: {},
    ticket_hash: {},
    btnText: {
      type: String,
    },
    hint: {},
    base: {},
    form_fields: {
      type: Array,
      default: () => [],
    },
    getResource: {},
    postResource: {},
    patchResource: {},
    deleteResource: {},
    prepare: {

    },
    value: {
      type: Array,
      default: () => [],
    },

  },
  data() {
    return {
      list: [],
      data: {},
      isLoad: false,
    }
  },
  computed: {
    eSlots() {
      return getESlots(Object.keys(this.$scopedSlots))
    },
  },
  watch: {
    value: {
      handler(nval) {
        this.list = nval
      },
      deep: true,
    },
  },
  async mounted() {
    // await this.getList()
    const i = this.list.length
    this.addFields()
    for (let x = 0; x <= i; x++) {
      if (!this.$refs[`validator${i}`]) return
      this.$refs[`validator${i}`][0].$el.addEventListener('blur', e => {
        this.$refs.validator.reset()
      }, true)
    }
  },
  methods: {
    catchFormErrors(promise, i) {
      return promise.catch(e => {
        const clientError = 400
        const serverError = 500
        if (!e.status || clientError > e.status || serverError <= e.status) {
          throw e
        }

        if (!this.updateValidator) {
          return e
        }

        return e.json().then(body => {
          const errors = {}

          body.errors.forEach(error => {
            if ('request' === error.domain && error.state) {
              Object.assign(errors, error.state)
            }
          })

          this.updateValidator(errors, i)

          return e
        })
      })
    },
    submit(valid, data, id) {
      if (!valid) {
        return Promise.reject()
      }

      this.isLoad = true
      return this.catchFormErrors(this.send(data), id)
        .finally(() => {
          this.isLoad = false
        })
    },
    async remove(i) {
      const question = this._('Вы действительно хотите удалить?')
      try {
        await confirmWithPromise(question, this)
        if (this.list[i].id) {
          this.deleteResource.execute({ id: this.list[i].id, label: this.ticket_hash })
        }
        this.list.splice(i, SPLITED_LENGTH)
      } catch (e) {
      }
    },
    addFields() {
      this.list.push(JSON.parse(JSON.stringify(this.base)))
    },
    async getList() {
      const { data: { items } } = (await this.getResource.execute({ label: this.ticket_hash }))
      this.list = items.map(el => el.props)
      if (!this.list.length) {
        this.addFields()
      }
    },
    async prepareData(valid, i) {
      this.$refs[`validator${i}`][0].validate()
      if (!valid) return
      const data = this.prepare(this.list[i])
      this.submit(valid, { ...data, idx: i }, i)
    },
    send(data) {
      const resource = data.id ? this.patchResource : this.postResource
      return resource.execute({ id: data.id, label: this.ticket_hash }, data)
        .then(res => {
          // const message = {
          //   message: {
          //     title: this._('Profile info create/update success header'),
          //     text: this._('Profile info create/update success text'),
          //   },
          // }
          // if (!data.id) {
          //   this.getList()
          // }
          this.$set(this.list[data.idx], 'id', res.data.id)
          this.list[data.idx].id = res.data.id
          this.$emit('input', this.list)
          // AnswerMessage(message, this)
          this.$refs[`validator${data.idx}`][0].reset()
        })
    },
    updateValidator(errors, i) {
      const parsed = defaultValidatorErrorsParser(errors)
      this.non_field_errors = parsed.non_field_errors
      this.$refs[`validator${i}`][0].setErrors(parsed)
    },
  },
}
</script>
